export const createTaskListUnit = `
    mutation CreateTaskListUnit($input: CreateTaskListUnitInput!) {
        createTaskListUnit(input: $input) {
            id
            ownerId
            workspaceId
            name
            description
            avatarPath
            timezone
            logicalDayShift
            isArchived
            taskLists
            taskListsOrder
            version
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;

export const updateTaskListUnit = `
    mutation UpdateTaskListUnit($input: UpdateTaskListUnitInput!) {
        updateTaskListUnit(input: $input) {
            __typename
            ... on TaskListUnit {
                id
                ownerId
                workspaceId
                name
                description
                avatarPath
                timezone
                logicalDayShift
                isArchived
                taskLists
                taskListsOrder
                version
                createdAt
                updatedAt
                createdBy
                updatedBy
            }
            ... on ConflictError {
                conflictType
                entityType
                entityId
                expectedVersion
                actualVersion
                currentState
                metadata
            }
        }
    }
`;

export const deleteTaskListUnit = `
    mutation DeleteTaskListUnit($input: DeleteTaskListUnitInput!) {
        deleteTaskListUnit(input: $input) {
            id
        }
    }
`;

export const deleteTaskList = `
    mutation DeleteTaskList($input: DeleteTaskListInput!) {
        deleteTaskList(input: $input) {
            id
            taskLists
            taskListsOrder
            version
        }
    }
`;

export const duplicateTaskListUnit = `
    mutation DuplicateTaskListUnit($input: DuplicateTaskListUnitInput!) {
        duplicateTaskListUnit(input: $input) {
            id
            ownerId
            workspaceId
            name
            description
            avatarPath
            timezone
            isArchived
            taskLists
            taskListsOrder
            version
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;

export const duplicateTaskList = `
    mutation DuplicateTaskList($input: DuplicateTaskListInput!) {
        duplicateTaskList(input: $input) {
            id
            taskLists
            taskListsOrder
            version
        }
    }
`;

export const createTask = `
    mutation CreateTask($input: CreateTaskInput!) {
        createTask(input: $input) {
            id
            taskListUnitId
            taskListId
            name
            description
            scheduleRule
            relatedPage
            config
            images
            isArchived
            version
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;

export const updateTask = `
    mutation UpdateTask($input: UpdateTaskInput!) {
        updateTask(input: $input) {
            __typename
            ... on Task {
                id
                taskListUnitId
                taskListId
                name
                description
                scheduleRule
                relatedPage
                config
                images
                isArchived
                version
                createdAt
                updatedAt
                createdBy
                updatedBy
            }
            ... on ConflictError {
                conflictType
                entityType
                entityId
                expectedVersion
                actualVersion
                currentState
                metadata
            }
        }
    }
`;

export const deleteTask = `
    mutation DeleteTask($input: DeleteTaskInput!) {
        deleteTask(input: $input) {
            id
        }
    }
`;

export const restoreTask = `
    mutation RestoreTask($input: RestoreTaskInput!) {
        restoreTask(input: $input) {
            id
            taskListUnitId
            taskListId
            name
            description
            scheduleRule
            relatedPage
            config
            images
            isArchived
            version
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;

export const restoreTaskListUnit = `
    mutation RestoreTaskListUnit($input: RestoreTaskListUnitInput!) {
        restoreTaskListUnit(input: $input) {
            id
            taskLists
            taskListsOrder
            version
        }
    }
`;

export const restoreTaskList = `
    mutation RestoreTaskList($input: RestoreTaskListInput!) {
        restoreTaskList(input: $input) {
            id
            taskLists
            taskListsOrder
            version
        }
    }
`;

export const createTaskReport = `
    mutation CreateTaskReport($input: CreateTaskReportInput!) {
        createTaskReport(input: $input) {
            id
            taskId
            taskListUnitId
            completedAt
            status
            comment
            images
            commentImages
            completedBy
            version
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;

export const updateTaskReport = `
    mutation UpdateTaskReport($input: UpdateTaskReportInput!) {
        updateTaskReport(input: $input) {
            __typename
            ... on TaskReport {
                id
                taskId
                taskListUnitId
                completedAt
                status
                comment
                images
                commentImages
                completedBy
                logicalDayStart
                version
                createdAt
                updatedAt
                createdBy
                updatedBy
            }
            ... on ConflictError {
                conflictType
                entityType
                entityId
                expectedVersion
                actualVersion
                currentState
                metadata
            }
        }
    }
`;

export const deleteTaskReport = `
    mutation DeleteTaskReport($input: DeleteTaskReportInput!) {
        deleteTaskReport(input: $input) {
            id
        }
    }
`;
